<div
    class="betriebskontakt-auswahl"
    [class.expanded]="isExpanded"
    [class.modern-style]="config.modernStyle"
>
    <!-- Header mit Titel und Auswahl-Info -->
    <div class="auswahl-header" *ngIf="config.title || config.multiSelect">
        <h3 class="auswahl-title" *ngIf="config.title">{{ config.title }}</h3>
        <div class="auswahl-info" *ngIf="config.multiSelect">
            <span class="selected-count">
                <span class="count-number">{{ getSelectedCount() }}</span>
                ausgewählt
            </span>
            <button
                mat-button
                color="warn"
                (click)="clearSelection()"
                [disabled]="getSelectedCount() === 0 || disabled"
                class="clear-button"
            >
                <mat-icon>clear</mat-icon>
                Auswahl löschen
            </button>
        </div>
    </div>

    <!-- Suchfeld -->
    <div class="search-section">
        <div class="search-container">
            <mat-form-field appearance="outline" class="search-field">
                <mat-label>{{ config.placeholder }}</mat-label>
                <input
                    matInput
                    [value]="searchTerm"
                    (input)="onSearchChange($event)"
                    (focus)="onSearchFocus()"
                    (blur)="onSearchBlur()"
                    placeholder="Nach Name, VVVO oder Ort suchen..."
                    [disabled]="disabled"
                />
                <mat-icon matSuffix>search</mat-icon>
            </mat-form-field>

            <!-- Plus-Button für neuen Kontakt -->
            <button
                *ngIf="config.allowCreateNew"
                mat-icon-button
                color="accent"
                (click)="oeffneNeuenKontaktDialog()"
                [disabled]="disabled"
                class="add-button"
                matTooltip="Neuen Kontakt erstellen"
            >
                <mat-icon>add</mat-icon>
            </button>
        </div>
    </div>

    <!-- Erweiterbarer Bereich -->
    <div class="expandable-section" [class.expanded]="isExpanded">
        <!-- Ladeindikator -->
        <div *ngIf="ladeKontakte" class="loading-section">
            <mat-spinner diameter="24"></mat-spinner>
            <span>Lade Kontakte...</span>
        </div>

        <!-- Kontaktliste -->
        <div *ngIf="!ladeKontakte" class="kontakte-list">
            <!-- Keine Kontakte -->
            <div *ngIf="filteredKontakte.length === 0" class="no-contacts">
                <mat-icon>contacts</mat-icon>
                <p *ngIf="searchTerm">Keine Kontakte für "{{ searchTerm }}" gefunden</p>
                <p *ngIf="!searchTerm">Keine Kontakte verfügbar</p>
            </div>

            <!-- Kontakte -->
            <div *ngIf="filteredKontakte.length > 0" class="kontakte-grid">
                <div
                    *ngFor="let kontakt of filteredKontakte"
                    class="kontakt-item"
                    [class.selected]="isKontaktSelected(kontakt)"
                    [class.disabled]="disabled"
                    (click)="onKontaktClick(kontakt)"
                >
                    <!-- Auswahl-Indikator -->
                    <div class="selection-indicator" *ngIf="config.multiSelect">
                        <mat-icon *ngIf="isKontaktSelected(kontakt)" class="selected-icon">check_circle</mat-icon>
                        <mat-icon *ngIf="!isKontaktSelected(kontakt)" class="unselected-icon"
                            >radio_button_unchecked</mat-icon
                        >
                    </div>

                    <!-- Kontakt-Info -->
                    <div class="kontakt-info">
                        <!-- Header mit Name und Badge -->
                        <div class="kontakt-header">
                            <div class="kontakt-name">
                                <h4 class="name">{{ kontakt.bezeichnung_final }}</h4>
                                <p *ngIf="kontakt.zusatz_final" class="zusatz">{{ kontakt.zusatz_final }}</p>
                            </div>
                            <span
                                class="betriebsart-badge"
                                [style.background-color]="getBetriebsartBadgeColor(kontakt.betriebsart_id)"
                            >
                                {{ getBetriebsartBadgeText(kontakt.betriebsart_id) }}
                            </span>
                        </div>

                        <!-- Details -->
                        <div class="kontakt-details">
                            <div class="detail-row" *ngIf="kontakt.vvvo">
                                <mat-icon>business</mat-icon>
                                <span>VVVO: {{ kontakt.vvvo }}</span>
                            </div>
                            <div class="detail-row" *ngIf="getVollAdresse(kontakt)">
                                <mat-icon>location_on</mat-icon>
                                <span>{{ getVollAdresse(kontakt) }}</span>
                            </div>
                            <div class="detail-row" *ngIf="getTelefonNummer(kontakt)">
                                <mat-icon>phone</mat-icon>
                                <span>{{ getTelefonNummer(kontakt) }}</span>
                            </div>
                            <div class="detail-row" *ngIf="kontakt.email">
                                <mat-icon>email</mat-icon>
                                <span>{{ kontakt.email }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- Favorit-Indikator -->
                    <div class="favorit-indicator" *ngIf="kontakt.favorit === 1">
                        <mat-icon class="favorit-icon">star</mat-icon>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Ende des erweiterbaren Bereichs -->

    <!-- Auswählen-Button nur für Multi-Select -->
    <div *ngIf="config.multiSelect && getSelectedCount() > 0 && config.showApplyButton !== false" class="auswahl-button-container">
        <button mat-raised-button color="primary" (click)="auswaehlen()" class="auswahl-button" [disabled]="disabled">
            <mat-icon>check</mat-icon>
            {{ getSelectedCount() === 1 ? "Kontakt auswählen" : getSelectedCount() + " Kontakte auswählen" }}
        </button>
    </div>
</div>
